import { motion, useScroll, useSpring } from "framer-motion";

/**
 * Ultra-thin brand-gradient scroll progress bar pinned to the top.
 */
export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <motion.div
      aria-hidden
      style={{ scaleX }}
      className="fixed top-0 left-0 right-0 z-[60] h-[3px] origin-left brand-gradient"
      data-testid="scroll-progress"
    />
  );
}
